import { useEffect } from 'react'
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { detect, fromNavigator, fromCookie } from '@lingui/detect-locale'

import { LanguageProvider } from './LanguageProvider'

const DEFAULT_FALLBACK = () => 'en'

export async function dynamicActivate(locale: string) {
  const finalLocale = locale.replace(/-.*$/, '')

  const { messages } = await import(`@/locales/${finalLocale}/messages.po`)

  i18n.load(locale, messages)
  i18n.activate(locale)
}

export function Provider({ children }: React.PropsWithChildren) {
  useEffect(() => {
    const result = detect(
      fromCookie('locale'),
      fromNavigator(window.navigator),
      DEFAULT_FALLBACK
    )

    if (result) dynamicActivate(result)
  }, [])

  return (
    <I18nProvider i18n={i18n}>
      <LanguageProvider>{children}</LanguageProvider>
    </I18nProvider>
  )
}
